/* @flow weak */

'use strict';

// setTimeout(() => {
    require(`../${__VENDOR__}.html`);

    const React = require('react');
    const ReactDOM = require('react-dom');
    const App = require('./components/app.jsx');
    //let a11y = require('react-a11y');

    // a11y is for enforcing accessibility standards. Check the console log for the warnings. For production, this function
    // is aliased to a blank function in webpack.config.js, thus making it do nothing.
    //a11y();


    // @TODO Current bug with babel-eslint throws an error saying App is not defined. Disabling the check for now. Remove once fixed

    /*eslint-disable no-undef */
    ReactDOM.render(<App />, document.getElementById('uc'));
    /*eslint-enable no-undef */
// }, __VENDOR__ == 'signet' ? 5000 : 0);


// WEBPACK FOOTER //
// ./src/base/scripts/main.jsx